var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',{staticClass:"mt-4"},[_c('BusinessTracking',{attrs:{"IdDirectory":_vm.selectedIdDirectory}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }